<template>
  <div class="hotBox">
    <div :style="defaultImg" class="boxshow" />
    <div class="w1200">
      <div class="hot_box">
        <a v-for="(item,index) in list" :key="index" :class="index===0?'bigBox':'smollBox'" :href="'/Detail?contentId='+item.CONTENT_ID" target="_blank" @mouseover="selectStyle(item)">
          <div class="shadow" />
          <div class="img_box">
            <img v-if="item.CONTENT_PHOTO_SMALL" :src="item.CONTENT_PHOTO_SMALL" alt="">
            <img v-else :src="noIMG" alt="">
            <p>{{ item.CONTENT_TITLE }}</p>
            <span class="hot_time">{{ item.CONTENT_ISSUE_DATE }}</span>
            <span class="el-icon-view viewNumber">{{ item.CONTENT_READING_SIZE }}</span>
            <span class="el-icon-star-on viewNumber viewStar">{{ item.CONTENT_COLLECTION_SIZE }}</span>
          </div>
        </a>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  props: ['list'],
  data() {
    return {
      // defaultImg: this.list[0].CONTENT_PHOTO_SMALL,
      defaultImg: {
        backgroundImage: '',
        backgroundRepeat: 'no-repeat'
      },
      noIMG: require('@/static/home_noimg.png')
    }
  },
  mounted() {
    if (this.list) {
      if (this.list.length > 0) {
        if (this.list[0].CONTENT_PHOTO_SMALL) {
          this.defaultImg.backgroundImage = 'url(' + this.list[0].CONTENT_PHOTO_SMALL + ')'
        }
      }
    }
  },
  methods: {
    // goDetail: function(contentId) {
    //   const { href } = this.$router.resolve({
    //     path: '/Detail',
    //     name: 'dt',
    //     query: {
    //       contentId
    //     }
    //   })
    //   window.open(href, '_blank')
    // },
    selectStyle: function(item) {
      // console.log(item)
      if (item.CONTENT_PHOTO_SMALL) {
        this.defaultImg = {
          backgroundImage: 'url(' + item.CONTENT_PHOTO_SMALL + ')',
          backgroundRepeat: 'no-repeat'
        }
      }
    }
  }
}
</script>

<style rel="stylesheet/scss" lang="scss" scoped>
  .hotBox{
    overflow: hidden;
    position: relative;
    margin-top: -5px;
    padding: 70px 0
  }
  .boxshow{
    position: absolute;
    width: 100%;
    height: 100%;
    left: 0;
    top: 0;
    background-color: #000;
    background-size: 100% auto;
    /*background-repeat: no-repeat;*/
    background-position: 50%;
    transition: background-image .1s ease 0s;
    /*-webkit-filter: blur(2px);*/
    /*filter: blur(2px);*/
  }
  .boxshow:after{
    position: absolute;
    width: 100%;
    height: 100%;
    left: 0;
    top: 0;
    background: rgba(0,0,0,.5);
    content: "";
  }
    .hot_box{
        width: 100%;
        height: 400px;
        overflow: hidden;
        font-size: 0;
    }
    .shadow{
      background-color:rgba(0,0,0,.3);
      width: 100%;
      height: 100%;
      z-index: 3;
      position: absolute;
      cursor: pointer;
      transition: 0.3s;
      &:hover{
        background-color: rgba(0,0,0,0);
      }
    }
    .bigBox{
        width: 600px;
        height: 400px;
        float: left;
      position: relative;
      display: inline-block;
        .img_box{
           width: 600px;
            height: 400px;
            overflow: hidden;
            font-size: 0;
          z-index: 2;
            img{
                width: 100%;
                height: 400px;
                vert-align: middle;
              z-index: 2;
              position: absolute;
              top: 0;
            }
          p{
            position: absolute;
            font-size: 18px;
            z-index: 10;
            color: #fff;
            top: 335px;
            height: 27px;
            display: -webkit-box;
            -webkit-box-orient: vertical;
            -webkit-line-clamp: 1;
            overflow: hidden;
            margin-left: 15px;
          }
        }
      .hot_time{
        position: absolute;
        top: 375px;
        left: 0;
        z-index: 10;
        display: inline-block;
        width: 50%;
        color: #e5e5e5;
        font-size: 12px;
        margin-left: 15px;
      }
      .viewNumber{
        position: absolute;
        z-index: 10;
        top: 375px;
        left: 460px;
        width: 25%;
        color: #e5e5e5;
        font-size: 12px;
        display: inline-block;
        height: 19px;
        line-height: 19px;
      }
      .viewStar{
        left: 530px;
      }
    }
    .smollBox{
        width:300px;
        height: 200px;
        display: inline-block;
        position: relative;
        .img_box{
            width: 300px;
            height: 200px;
            overflow: hidden;
            font-size: 0;
            img{
                width: 100%;
                height: 200px;
                vert-align: middle;
              z-index: 2;
              position: absolute;
              top: 0;
            }
        }
       p{
         position: absolute;
         font-size: 14px;
         color: #fff;
         top: 140px;
         height: 40px;
         display: -webkit-box;
         -webkit-box-orient: vertical;
         -webkit-line-clamp: 2;
         overflow: hidden;
         margin-left: 15px;
         z-index: 10;

       }
      .hot_time{
        position: absolute;
        top: 175px;
        left: 0;
        z-index: 10;
        display: inline-block;
        width: 50%;
        color: #e5e5e5;
        margin-left: 15px;
      }
      .viewNumber{
        position: absolute;
        z-index: 10;
        top: 175px;
        left: 195px;
        width: 25%;
        color: #e5e5e5;
        font-size: 12px;
        display: inline-block;
        height: 19px;
        line-height: 19px;
      }
      .viewStar{
        left: 250px;
      }
    }

</style>

<!--手机端样式-->
<style rel="stylesheet/scss" lang="scss" scoped>
  @media screen and (max-width: 750px) {
    .hot_box{
      height: auto;
    }
    .bigBox{
      width: 100%;
      height: auto;
      text-shadow: 1px 1px 1px #333,-1px -1px 1px #333;
      .shadow{
        background: none;
      }
      .img_box{
        width: 100%;
        height: auto;
        position: relative;
        img{
          height: auto;
          position: relative;
        }
        p{
          bottom: 40px;
          top: auto;
        }
        .hot_time,.viewNumber{
          bottom: 20px;
          top: auto;
        }
        .el-icon-view{
          left: auto;
          right: 60px;
          width: auto;
        }
        .el-icon-star-on{
          left: auto;
          right: 20px;
          width: auto;
        }
      }
    }
    .smollBox{
      width: 100%;
      height: auto;
      text-shadow: 1px 1px 1px #333,-1px -1px 1px #333;
      .shadow{
        display: none;
      }
      .img_box{
        width: 100%;
        height: auto;
        img{
          width: 100%;
          height: auto;
          position: relative;
        }
        p{
          top: auto;
          bottom: 40px;
        }
        .hot_time,.viewNumber{
          top: auto;
          bottom: 20px;
        }
        .el-icon-view{
          left: auto;
          right: 60px;
          width: auto;
        }
        .el-icon-star-on{
          left: auto;
          right: 20px;
          width: auto;
        }
      }
    }
  }
</style>
